import React from 'react';
import { GenericCardsContainer } from '../GenericCards/GenericCardStyle';
import { SetupContext } from 'src/consumer/context/SetupContext';
import { useContext } from 'react';
import { getCategoryListMap } from 'src/consumer/helpers/courseCardHelper';
import { AssessmentButtonTile, AssessmentCardBackgroundTile, AssessmentCardContainerTile, AssessmentCardTitleAndButtonTile, AssessmentCategoryTile, AssessmentInfoSeparator, AssessmentTitleTile } from './AssessmentCardStyles';
import { mediaURL } from 'src/consumer/services';
import { defaultBgImgId } from 'src/consumer/constants';
import { useNavigate } from 'react-router-dom';

export const renderCardsList = (props, setupData, navigate) => {
    const { cardsType, cardsCategory, cardsData } = props;

    return cardsData?.map((item, index) => {

        const data = item?.assessment
        const category = getCategoryListMap(setupData)?.get?.[cardsType]

        if (item?.assessment?.enabled) {
            let imgUrl = data?.coverIcon ? `${mediaURL}${data?.coverIcon}` : `${mediaURL}${defaultBgImgId}`

            return (

                <AssessmentCardContainerTile
                    key={index}
                    onClick={() => {
                        navigate(`/assessment/${data?.slug}`)
                    }}
                >
                    <AssessmentCardBackgroundTile imgURL={imgUrl} />
                    <AssessmentCardTitleAndButtonTile>
                        {category && <AssessmentCategoryTile>{category}</AssessmentCategoryTile>}
                        <AssessmentInfoSeparator />
                        <AssessmentTitleTile>
                            {data?.title}
                        </AssessmentTitleTile>
                        <AssessmentButtonTile>Take Test</AssessmentButtonTile>
                    </AssessmentCardTitleAndButtonTile>
                </AssessmentCardContainerTile>
            )
        } else {
            return null;
        }
    })
}

const AssessmentCards = (props) => {

    const { setupData } = useContext(SetupContext);
    const navigate = useNavigate();

    return (
        <GenericCardsContainer>
            {renderCardsList(props, setupData, navigate)}
        </GenericCardsContainer>
    )
}

export default AssessmentCards;